// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1NoIa","footer":"ModalUpdate_footer__3L7ls"};